import { Component } from '@angular/core';
import { BaseControlComponent } from '../../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../../form-controls/services/context-interaction.service';

@Component({
    selector: 'data-table-config',
    templateUrl: './data-table-data-config.component.html',
    styleUrls: ['./data-table-data-config.component.scss'],
    standalone: false
})
export class DataTableDataConfigComponent extends BaseControlComponent {

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    static componentName = 'DataTableDataConfigComponent';

}
